export default __webpack_public_path__ + "static/media/12.cb2f7b7e.png";